function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "info");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Artboard-Copy-8",
  transform: "translate(-549.000000, -846.000000)",
  fill: "currentColor",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "Group-2",
  transform: "translate(539.000000, 835.000000)"
}, React.createElement("path", {
  d: "M18.3333333,11 C13.7333333,11 10,14.7333333 10,19.3333333 C10,23.9333333 13.7333333,27.6666667 18.3333333,27.6666667 C22.9333333,27.6666667 26.6666667,23.9333333 26.6666667,19.3333333 C26.6666667,14.7333333 22.9333333,11 18.3333333,11 Z M19.1666667,23.5 L17.5,23.5 L17.5,18.5 L19.1666667,18.5 L19.1666667,23.5 Z M19.1666667,16.8333333 L17.5,16.8333333 L17.5,15.1666667 L19.1666667,15.1666667 L19.1666667,16.8333333 Z",
  id: "info"
}))));

var SvgInfo = function SvgInfo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgInfo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/info.cab44abb.svg";
export { ForwardRef as ReactComponent };